import { render, staticRenderFns } from "./ManageSso.vue?vue&type=template&id=3a61df0c"
import script from "./ManageSso.vue?vue&type=script&lang=js"
export * from "./ManageSso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports